import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import Button from "@material-ui/core/Button";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import InboxIcon from "@material-ui/icons/MoveToInbox";
import MailIcon from "@material-ui/icons/Mail";
import Container from "@material-ui/core/Container";
import TextField from "@material-ui/core/TextField";

import Sets from "../shared/Sets";
import CollectionNames from "../shared/CollectionNames";

import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import IconButton from "@material-ui/core/IconButton";
import LanguageNames from "../shared/LanguageNames";
import VerbTypes from "./VerbTypes";
import VerbRegular from "./VerbRegular";
import VerbFrequency from "./VerbFrequency";

import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import PropTypes from "prop-types";
import Typography from "@material-ui/core/Typography";

import PhoneIcon from "@material-ui/icons/Tune";
import FavoriteIcon from "@material-ui/icons/Spellcheck";
import StarIcon from "@material-ui/icons/Star";
import CollectionLetters from "../shared/CollectionLetters";
import CollectionLevels from "../shared/CollectionLevels";
import Fab from '@material-ui/core/Fab';

const useStyles = makeStyles({
  list: {
    //  width: 250,
  },
  myul: {
    //  maxHeight: 700,
    // overflowY:'scroll',
    //overflow-y: scroll,
  },
  limit: {
    width: 100,
  },booked:{
    background: "rgba(200,200,200,0.2)",
    color:"orange",
  },
  myDrawer: {
    width: 250,
    // width:150
  },
  fullList: {
    width: "auto",
    //    maxWidth:200
  },
});

function TabContainer(props) {
  return (
    <Typography component="div" style={{ padding: 8 * 3 }}>
      {props.children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

export default function VerbsSwipeableTemporaryDrawer(props) {
  const classes = useStyles();
  const [state, setState] = React.useState({
    language: "Spanish",
    languages: [{ name: "Spanish" }, { name: "French" }],
    tab: 0,
  });

  function handleLanguageChange(name) {
    setState({
      ...state,
      language: name,
    });
    props.handleLanguageChange(name);
  }
  // function handleSettingChange(name) {
  //   // setState({
  //   //   ...state, language: name
  //   //   })
  //   props.handleSettingChange(name);
  // }

  function handleChange(e) {
    setState({
      ...state,
      [e.target.id]: e.target.value,
    });
  }

  function handleTabChange(event, newValue) {
    // alert(newValue);
    setState({
      ...state,
      tab: newValue,
    });
    //setValue(newValue);
  }

  const toggleDrawer = (side, open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [side]: open });
  };

  function handleBookmarkFilter(event) {
    props.handleBookmarkFilter(event);
  }
  
  function LetterClick(letter) {
    props.LetterClick(letter);
  }
  return (
    <div>
      {/* <Button onClick={toggleDrawer('left', true)}>Open Left</Button> */}

      <div hidden id="main_button_helper" onClick={toggleDrawer("right", true)}>
        Open Right
      </div>

      <SwipeableDrawer
        anchor="right"
        open={state.right}
        onClose={toggleDrawer("right", false)}
        onOpen={toggleDrawer("right", true)}
      >
        <div className={classes.myDrawer}>
          <Tabs
            id="tab"
            value={state.tab}
            onChange={handleTabChange}
            variant="fullWidth"
            indicatorColor="primary"
            textColor="secondary"
            aria-label="icon label tabs example"
          >
            <Tab icon={<PhoneIcon />} />
            <Tab icon={<FavoriteIcon />} />
            <Tab icon={<StarIcon />} />
          </Tabs>

          {state.tab === 0 && (
            <TabContainer>
              <Container fixed>
                <br></br>

                <LanguageNames
                  language={props.language}
                  handleLanguageChange={handleLanguageChange}
                ></LanguageNames>
                <br></br>
                <br></br>
                <VerbTypes
                  verb_type={props.verb_type}
                  handleSettingChange={props.handleSettingChange}
                ></VerbTypes>
                <br></br>
                <br></br>
                <VerbRegular
                  regular={props.regular}
                  handleSettingChange={props.handleSettingChange}
                ></VerbRegular>
                <br></br>
                <br></br>
                <VerbFrequency
                  frequency={props.frequency}
                  handleSettingChange={props.handleSettingChange}
                ></VerbFrequency>
                <br></br>
                <br></br>

                <CollectionLevels handleCollectionLevelChange={props.handleCollectionLevelChange}></CollectionLevels>
                <br></br>
                <br></br>
                <Button onClick={() => handleBookmarkFilter(true)} variant="contained">Bookmarked</Button>
            {/*    <Fab  variant="extended" size="small"  className={classes.booked} aria-label="add">
                   <FavoriteIcon fontSize="small"></FavoriteIcon>
                  
               </Fab>
                 <IconButton
                  onClick={() => handleBookmarkFilter(true)}
                  size="small"
                >
                  <FavoriteIcon fontSize="small"></FavoriteIcon>
                </IconButton> */}
              </Container>
            </TabContainer>
          )}
          {state.tab === 1 && (
            <TabContainer><CollectionLetters LetterClick={LetterClick}></CollectionLetters></TabContainer>
          )}
        </div>
      </SwipeableDrawer>
    </div>
  );
}
